import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { MochilaService } from '../services/mochila.service';
import { TipoMochilaService } from '../services/tipo-mochila.service';
import { ProdutoService } from '../services/produto.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';

import Swal from 'sweetalert2';

@Component({
	selector: 'app-mochila-edit',
	templateUrl: './mochila-edit.component.html',
	styleUrls: ['./mochila-edit.component.css'],
	animations: [loadingFade]
})
export class MochilaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public mochila_id = null;
	public mochila = [];

	public formMochila: FormGroup;
	public tipos_mochila = [];

	public tipos_servicos = [];
	public produtos_array = [];
	public clientes = [];

	public agencias = [];
	public unidades = [];

	public href: string = "";
	public hiddenSubmit = false;

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private mochilaSvc: MochilaService,
		private tipoMochilaSvc: TipoMochilaService,
		private produtoSvc: ProdutoService,
		private clienteSvc: ClienteService,
		private unidadeSvc: UnidadeService
	) { }

	ngOnInit() {

		this.href = this.router.url;
		let path = this.router.url;	
		let pathS = path.split("/"); 

		console.log("[path] = " + pathS[3]);
	
		if(pathS[3] == "ver"){
		  this.criaFormDisabled();
		  this.hiddenSubmit = true;
		}else{
		  this.criaForm();
		}


		//this.pegaProdutos();
		this.pegaTiposMochila();
		//this.criaForm();
		this.pegaAgencias();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.mochila_id = params.id;
				this.mochilaSvc.getMochila(params.id).then((data: any) => {

					this.pegaUnidadesByAgencia(data.cliente_id);

					this.preencheForm({
						mochila_id: data.mochila_id,
						mochila_nome: data.mochila_nome,
						mochila_codigo: data.mochila_codigo,
						tipo_mochila_id: data.tipo_mochila_id,
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						produtos: []
					});

					for (let produto of data.produtos) {
						this.addProduto(produto.produto_nome, produto.mochila_produto_quantidade, pathS[3]);
					}


					this.loading = false;
				});
			}
			else {
				this.addProduto();
				this.loading = false;
			}
		});
	}

	pegaClientes(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.clientes = data;
		});
	}



	criaForm() {
		this.formMochila = this.fb.group({
			mochila_id: '',
			cliente_id: [null, Validators.required],
			unidade_id: [null, Validators.required],
			mochila_nome: [null, Validators.required],
			mochila_codigo: [null, Validators.required],
			tipo_mochila_id: [null, Validators.required],
			produtos: this.fb.array([]),
		});
	}

	criaFormDisabled(){

		console.log("[criaFormDisabled]");

		this.formMochila = this.fb.group({
			mochila_id: '',
			cliente_id: {value: null, disabled: true},
			unidade_id: {value: null, disabled: true},
			mochila_nome: {value: null, disabled: true},
			mochila_codigo: {value: null, disabled: true},
			tipo_mochila_id: {value: null, disabled: true},
			produtos: this.fb.array([]),
		});
	}

	pegaTiposMochila() {
		this.tipoMochilaSvc.getTiposMochilaAtivas().then((data: any[]) => {
			this.tipos_mochila = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaProdutos() {
		this.produtoSvc.getProdutos().then((data: any[]) => {
			this.produtos_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formMochila.setValue(dados);
	}

	enviaMochila() {
		if (this.formMochila.valid) {
			this.submitting = true;

			let toSend = this.formMochila.value;
			if (this.mochila_id === null) {
				this.mochilaSvc.criaMochila(toSend).then((data: any) => {
					Swal.fire({
						type: 'success',
						title: 'Manutenção cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/mochila']);
						}
					});
				}).catch((err) => {
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else {
				this.mochilaSvc.editaMochila(toSend).then((data: any) => {
					Swal.fire({
						type: 'success',
						title: 'Manutenção cadastrada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/mochila']);
						}
					});
				}).catch((err) => {
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formMochila.controls) {
				let campo = this.formMochila.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formMochila.get(nome);
		return input.touched && input.invalid;
	}

	createItemPeca(produto_nome = null, mochila_produto_quantidade = null) {
		return this.fb.group({
			produto_nome: [produto_nome, [Validators.required]],
			mochila_produto_quantidade: [mochila_produto_quantidade, [Validators.required]]
		})
	}

	createItemPecaVer(produto_nome = null, mochila_produto_quantidade = null) {
		return this.fb.group({
			produto_nome: {value: produto_nome, disabled: true},
			mochila_produto_quantidade: {value: mochila_produto_quantidade, disabled: true}
		})
	}

	addProduto(produto_nome = null, mochila_produto_quantidade = null, ver = null) 
	{

		const produtos = this.formMochila.get('produtos') as FormArray;
		if(ver == "ver"){

			produtos.push(this.createItemPecaVer(produto_nome, mochila_produto_quantidade));

		}else if (produto_nome != null && mochila_produto_quantidade != null) 
		{
			produtos.push(this.createItemPeca(produto_nome, mochila_produto_quantidade));

		}else {
			produtos.push(this.createItemPeca());
		}
	}

	removeProduto(index) {
		const produtos = this.formMochila.get('produtos') as FormArray;
		produtos.controls.length == 1 || produtos.removeAt(index);
	}

	pegaAgencias(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.agencias = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  pegaUnidadesByAgencia(agencia_id){

		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	
	  }

	  verificaCliente() {
		if (this.formMochila.get('cliente_id').value)
			this.formMochila.get('unidade_id').enable();
		else
			this.formMochila.get('unidade_id').disable();
  }
  

	  onChangeAgencia(e){
		this.formMochila.controls.unidade_id.setValue(null);
		this.verificaCliente();

		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }


	  
}
